import { StandardLoginPage } from './components/StandardLoginPage';

export default function LoginPage() {
  return <StandardLoginPage defaultReturnPath={'/'} />;
}
